import { createSlice } from "@reduxjs/toolkit"
import { addLocalStorageCart, getLocalStorageCart } from '../../utils/localStorage'
import { getAlicuotaPercent } from '../../utils/tax'

const cartItems = getLocalStorageCart()

const initialState = {
    cartItems: cartItems ? cartItems : [],
    totalCount: 0,
    totalAmount: 0,
    subTotal: 0,
    tax: 0
}

export const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        clearCart: (state) => {
            state.cartItems = []
        },
        addToCart: (state, action) => {
            let cartIndex = state.cartItems.findIndex((item) => item.id === action.payload.id)
            // Increasing the quantity of the product
            if (cartIndex >= 0) {
                if (state.cartItems[cartIndex].quantity < state.cartItems[cartIndex].stock) {
                    state.cartItems[cartIndex].quantity += 1
                }
            } else {
                // index -1
                // New product to cart add 
                 // Asegurar que el item en el carrito incluya alicuotaIVACode (por compatibilidad con backend)
                 const payloadWithAlic = {
                     ...action.payload,
                     quantity: 1,
                     // Use nullish coalescing to accept 0 as a valid code
                     alicuotaIVACode: action.payload.alicuotaIVACode ?? action.payload.alicuotaIVA ?? 5
                 }
                 state.cartItems.push(payloadWithAlic)
            }
            addLocalStorageCart(state.cartItems)
        },
        productSubTotal: (state) => {
            state.subTotal = state.cartItems.reduce((subTotal, product) => {
                const { price, quantity } = product
                return subTotal + price * quantity
            }, 0)
        },
        productTax: (state) => {
            // Calculate tax per item using its alicuotaIVACode. If item has alicuota 0, it's exento.
            const productTax = state.cartItems.reduce((acc, item) => {
                const qty = item.quantity || 1
                const price = Number(item.price) || 0
                const code = typeof item.alicuotaIVACode !== 'undefined' ? item.alicuotaIVACode : (item.alicuotaIVA ?? 5)
                const rate = getAlicuotaPercent(code) / 100
                if (!rate) return acc
                return acc + price * qty * rate
            }, 0)
            state.tax = Number(productTax.toFixed(2))
        },
        productTotalAmount: (state) => {
            state.totalAmount = Number((state.subTotal + state.tax).toFixed(2))
        },
        increase: (state, action) => {
            const product = state.cartItems.find((item) => item.id === action.payload)
            if (product.quantity < product.stock) {
                 product.quantity = product.quantity + 1
            } else {
                 product.quantity = product.stock
            }
            addLocalStorageCart(state.cartItems)
        },
        decrease: (state, action) => {
            const product = state.cartItems.find((item) => item.id === action.payload)
            if (product.quantity <= 1) {
                product.quantity = 1
            } else {
                product.quantity = product.quantity - 1
            }
            addLocalStorageCart(state.cartItems)
        },
        removeCartItem: (state, action) => {
            state.cartItems = state.cartItems.filter((item) => item.id !== action.payload)
            addLocalStorageCart(state.cartItems)
        }
    },
})

export const { clearCart, addToCart, productSubTotal, productTax, productTotalAmount, increase, decrease, removeCartItem } = cartSlice.actions;
export default cartSlice.reducer